import { createContext, useContext } from 'react';

export interface NavButtonContextType {
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
  toggleExpanded: () => void;
}

export const NavButtonContext = createContext<NavButtonContextType | undefined>(undefined);

export function useNavButton() {
  const context = useContext(NavButtonContext);
  if (context === undefined) {
    throw new Error('useNavButton must be used within a NavButtonProvider');
  }
  return context;
}
